import { render, staticRenderFns } from "./How.vue?vue&type=template&id=a8a2abf0"
var script = {}
import style0 from "./How.vue?vue&type=style&index=0&id=a8a2abf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports